<template>
  <div class="marketing-activity-user-participation">
    <h1 class="highlight">奖品内容</h1>
    <div class="my-1">
      <el-table :data="prizeList" border size="small">
        <el-table-column label="奖品类型" prop="type">
          <template slot-scope="{row}">
            {{ prizeTypeMap[row.type] }}
          </template>
        </el-table-column>
        <el-table-column label="奖品名称" prop="name" />
        <el-table-column label="总计数量" prop="num">
          <template slot-scope="{row}">
            {{ row.num === -1 ? '不限' : row.num }}
          </template>
        </el-table-column>
        <el-table-column label="领取规则" prop="pickRule" show-overflow-tooltip>
          <template slot-scope="{row}">
            <div style="white-space: pre;">{{ row.pickRule }}</div>
          </template>
        </el-table-column>
        <el-table-column label="领取限制" prop="limitType">
          <template slot-scope="{row}">
            {{ row.limitType === 10 ? '不限制' : row.limitType === 20 ? '每人限领'+row.limitNum+'份' : row.limitType === 30 ? '每户限领'+row.limitNum+'份' : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="已领取份数" prop="pickGiftNum" />
      </el-table>
    </div>

    <h1 class="highlight mt-2">用户参与详情</h1>

    <el-form inline class="filter-form mt-1">
      <el-form-item>
        <el-form-item class="remove-mb">
          <el-select v-model="formData.searchType" placeholder="请选择">
            <el-option :label="item.label" :value="item.value" v-for="(item, index) in searchTypeList" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item class="remove-mb">
          <el-input v-model="formData.search" placeholder="" />
        </el-form-item>
      </el-form-item>

      <el-form-item>
        <el-select v-model="formData.receiveState" placeholder="请选择">
          <el-option :label="item.label" :value="item.value" v-for="(item, index) in receiveStateList" :key="index" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-select v-model="formData.writeOffState" placeholder="请选择">
          <el-option :label="item.label" :value="item.value" v-for="(item, index) in writeOffState" :key="index" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-form-item class="remove-mb">
          <el-select v-model="formData.dateType" placeholder="请选择">
            <el-option :label="item.label" :value="item.value" v-for="(item, index) in dateTypeList" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item class="remove-mb">
          <el-date-picker
            v-model="formData.datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="搜索开始时间"
            end-placeholder="搜索结束时间">
          </el-date-picker>
        </el-form-item>
      </el-form-item>

      <el-form-item>
        <el-button @click="handleSearch" :loading="loading" type="primary">查询</el-button>
        <el-button @click="handleReset" :disabled="loading" type="">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="flex items-center mb-1">
      <el-button type="primary" @click="handleExport">导出</el-button>
    </div>

    <div class="mt-1">
      <el-table :data="tableData" border v-loading="loading">
        <el-table-column label="用户 ID" align="center" prop="uid" />
        <el-table-column label="用户名称" align="center" prop="username" />
        <el-table-column label="手机号" align="center" prop="phone" width="100">
          <template slot-scope="{row}">
            {{ row.phone ? truncateString(row.phone) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="农户姓名" align="center" prop="personName" />
        <el-table-column label="注册时间" align="center" prop="registerTime" min-width="180" />
        <el-table-column label="开始参与时间" align="center" prop="joinTime" min-width="180" />
        <el-table-column label="奖品领取状态" align="center" prop="pickStatus" width="120">
          <template slot-scope="{row}">
            {{ row.pickStatus ? receiveStateList.find(i => i.value === row.pickStatus).label || '' : '' }}
          </template>
        </el-table-column>
        <el-table-column label="已领取的奖品" align="center" prop="pickGift" min-width="250">
          <template slot-scope="{row}">
            <div v-html="getDisplayPrizeText(row.pickGift)">
            </div>
          </template>
        </el-table-column>
        <el-table-column label="未领取的奖品" align="center" prop="noPickGift" min-width="250">
          <template slot-scope="{row}">
            <div v-html="getDisplayPrizeText(row.noPickGift)">
            </div>
          </template>
        </el-table-column>
        <el-table-column label="实物奖品核销状态" align="center" prop="writeOffStateStr" width="160" />
        <el-table-column label="发放备注" align="center" prop="remark" min-width="120" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{ row.remark || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="210" align="center" fixed="right">
          <template slot-scope="{row}">
            <el-link type="primary" size="small" class="mx-2px" @click="handleDialogDisplay(row, 'showTaskProgressDialog')">查看任务完成情况</el-link>
            <el-link v-if="canWriteOff && row.writeOffState !== 30" type="success" size="small" class="mx-2px" @click="handleDialogDisplay(row, 'showWriteOffDialog')">核销奖品</el-link>
          </template>
        </el-table-column>
      </el-table>

      <div class="flex justify-end mt-1" v-if="totalCount">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
          :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount" background>
        </el-pagination>
      </div>
    </div>

    <TaskProgressDialog :show.sync="showTaskProgressDialog" :recordId="selectedRow ? selectedRow.id : ''" />
    <WriteOffDialog @refresh="loadData" :show.sync="showWriteOffDialog" :recordId="selectedRow ? selectedRow.id : ''" :zxmUserId="selectedRow ? selectedRow.uid : ''" />
  </div>
</template>

<script>
import TableMixin from '@/mixins/table'
import { truncateString } from '@/utils/text'
import WriteOffDialog from './components/WriteOffDialog.vue'
import TaskProgressDialog from './components/TaskProgressDialog.vue'

import {
  getActivityPrizeListApi,
  getActivityUserListApi,
  getActivityUserParticipationExportApi,
} from '@/api'
import {exportToFile} from '@/utils/export'

export default {
  name: "MarketingActivityUserParticipation",
  mixins: [TableMixin],
  components: {WriteOffDialog, TaskProgressDialog},
  beforeRouteEnter(to, from, next) {
    // 动态修改面包屑中的活动名称
    to.meta.title=to.query.title ? `${to.query.title} - ` + '参与详情' : '活动参与详情'
    next()
  },
  data() {
    return {
      truncateString,

      /** 活动id */
      activityId: '',

      selectedRow: null,
      showTaskProgressDialog: false,
      showWriteOffDialog: false,

      prizeTypeMap: {
        10: '智小美生活卡',
        20: '实物', 
        30: '优惠券', 
        40: '红包'
      },

      searchTypeList: [
        {label: '用户名称', value: 'username'},
        {label: '用户 ID', value: 'uid'},
        {label: '手机号', value: 'phone'},
        {label: '农户姓名', value: 'personName'},
      ],

      receiveStateList: [
        {label: '奖品领取状态', value: null}, // 全部
        {label: '已领取全部', value: 30},
        {label: '只领取部分', value: 20},
        {label: '暂未领取', value: 10},
      ],

      dateTypeList: [
        {label: '开始参与时间', value: 'partin'},
        {label: '注册时间', value: 'register'},
      ],

      writeOffState: [
        {label: '实物奖品核销状态', value: null},
        {label: '全部核销', value: 30},
        {label: '部分核销', value: 20},
        {label: '未核销', value: 10},
      ],

      formData: {
        searchType: 'username',
        search: '',
        receiveState: null,
        dateType: 'partin',
        datetime: null,
        writeOffState: null,
      },

      tableData: [],
      prizeList: [],
    }
  },

  computed: {
    /** 是否可核销，只有有实物奖品时才可核销 */
    canWriteOff() {
      return this.prizeList.some(item => item.type === 20)
    },
  },

  async beforeMount() {
    this.activityId = this.$route.query.id
    if (!this.activityId) {
      this.$router.go(-1)
      return this.$message.error('无效活动！')
    }

    await this.loadData()
  },

  methods: {

    /** 
     * 已领取/未领取奖品的显示
     * @param {Array} data 奖品列表
     */
    getDisplayPrizeText(data) {
      if (!data || !data.length) {
        return '-'
      }

      return data.map((item, index) => `<div>${index+1}、${item.activityPrizeName}</div>`).join('')
    },

    async handleExport() {
      try {
        let params = {
          activityId: this.activityId,
          dateType: this.formData.dateType,
          startTime: this.formData.datetime ? this.formData.datetime[0] : '',
          endTime: this.formData.datetime ? this.formData.datetime[1] : '',
          receiveState: this.formData.receiveState,
          [this.formData.searchType]: this.formData.search,
          writeOffState: this.formData.writeOffState,
        }
        await getActivityUserParticipationExportApi(params)
      } catch(err) {
        console.log(err)
      }
    },

    async getActivityPrize() {
      try {
        let res = await getActivityPrizeListApi(this.activityId)
        if (res.code === 0) {
          this.prizeList = res.data
        }
      } catch(err) {
        console.log(err)
      }
    },

    /** 
     * 根据 type 显示对应弹框弹框
     * @param {String} type showTaskProgressDialog | showWriteOffDialog
     */
    handleDialogDisplay(data, type) {
      this.selectedRow = data
      this[type] = true
    },

    async handleSearch() {
      this.pageIndex = 1
      this.tableData = []
      this.totalCount = 0
      await this.getTableList()
    },
    async handleReset() {
      this.formData = {
        searchType: 'username',
        search: '',
        receiveState: null,
        dateType: 'partin',
        datetime: null,
        writeOffState: null,
      }
      this.pageIndex = 1
      this.tableData = []
      this.totalCount = 0
      await this.getTableList()
    },

    async getTableList() {
      try {
        let {
          searchType,
          search,
          receiveState,
          dateType,
          datetime,
          writeOffState,
        } = this.formData

        let endTime = ''
        let startTime = ''
        if (datetime) {
          startTime = datetime[0]
          endTime = datetime[1]
        }

        let params = {
          writeOffState,
          dateType,
          [searchType]: search,
          endTime,
          startTime,
          receiveState,
        }

        let res = await getActivityUserListApi({
          current: this.pageIndex,
          size: this.pageSize,
          activityId: this.activityId,
          ...params,
        })
        if (res.code === 0) {
          this.tableData = res.data.records
          this.totalCount = Number(res.data.total)
        }
      } catch(err) {
        console.log(err)
      }
    },

    async loadData() {
      await Promise.all([this.getActivityPrize(), this.getTableList()])
    },
  },
}
</script>

<style lang="less" scoped>
.filter-form {
  .remove-mb {
    margin-bottom: 0 !important;
  }
}
</style>